import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class NwAddKeywordsComponent extends Component {
  @service theme;
  get currentTheme() {
    return this.theme.current;
  }
}
